var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardAmericanExpressicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    rx: 2,
    fill: "#016FD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.74 13.35V15.306H24.256L23.338 14.232L22.384 15.306H15.328V9.588H13L15.91 3H18.742L19.426 4.494V3H22.942L23.53 4.566L24.106 3H26.74V3.92999H24.706L23.782 6.36601L23.536 7.02599L22.354 3.92999H20.32V8.72998L18.208 3.92999H16.57L14.446 8.72998H15.838L16.21 7.806H18.538L18.91 8.72998H20.32H21.544V5.604L21.538 4.97399L21.778 5.604L22.948 8.72998H24.112L25.288 5.604L25.516 4.98V8.72998H26.74V10.608L25.384 11.97L26.74 13.35ZM16.312 14.376V9.59397H20.32V10.632H17.536V11.472H20.266V12.504H17.536V13.338H20.32V14.376H16.312ZM26.368 14.376H24.778L23.326 12.816L21.868 14.376H20.32L22.558 11.994L20.32 9.59397H21.916L23.356 11.148L24.802 9.59397H26.368L24.124 11.976L26.368 14.376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.374 4.95599L17.134 5.55601L16.636 6.76798H18.112L17.614 5.55601L17.374 4.95599Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 17,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAmericanExpressicon);
export default __webpack_public_path__ + "static/media/card-american-express.icon.dbb7db5bbf656411096f3474fb18ea47.svg";
export { ForwardRef as ReactComponent };